/**
 * Localized month names for the application
 */

export const MONTH_NAMES = {
  ar: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "ماي",
    "يونيو",
    "يوليوز",
    "غشت",
    "شتنبر",
    "أكتوبر",
    "نونبر",
    "دجنبر"
  ],
  fr: [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre"
  ]
} as const;

/**
 * Get localized month names based on current language
 */
export const getMonthNames = (language: 'ar' | 'fr'): readonly string[] => {
  return MONTH_NAMES[language] || MONTH_NAMES.ar;
};
